module.exports = __webpack_public_path__ + "media/images/caregiver/caregiver_avatar_04-83ccbd3bde7efb84eba98a21317f2dd0.png";